// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './ma... Remove this comment to see the full error message
import main from './main';
main.start();